<template>
  <div class="bg fill-height">
    <app-header></app-header>
    <v-container class="pt-0 pb-0">
      <transition-group name="fade" mode="out-in">
        <v-layout v-if="item !== null" v-bind:key="1" row wrap class="justify-center">
        <v-flex xs12 class="lead text-xs-center sans dark">{{item.meta_title || '-'}}</v-flex>
        <v-flex xs12 layout wrap row class="justify-space-around " align="stretch">
          <v-flex xs12 md4 class="pa-3" layout row align="stretch">
            <v-flex xs12 layout row wrap class="accent pa-3 box">
              <v-flex xs12 class="text-xs-center sans title white--text">Data apertura</v-flex>
              <v-flex xs12 class="text-xs-center sans text white--text">{{item.meta_opened_at | date}}</v-flex>
            </v-flex>
          </v-flex>
          <v-flex xs12 md4 class="pa-3" layout row align="stretch">
            <v-flex xs12 layout row wrap class="white pa-3 box">
              <v-flex xs12 class="text-xs-center sans title dark">Soggetto gestore</v-flex>
              <v-flex xs12 class="text-xs-center sans text dark">
                {{item.cciaa.name}}
              </v-flex>
            </v-flex>
          </v-flex>
          <v-flex xs12 md4 class="pa-3" layout row align="stretch">
            <v-flex xs12 layout row wrap class="primary pa-3 box">
              <v-flex xs12 class="text-xs-center sans title white--text">Data chiusura</v-flex>
              <v-flex xs12 class="text-xs-center sans text white--text">{{item.meta_closed_at | date}}</v-flex>
            </v-flex>
          </v-flex>
        </v-flex>
        <v-flex xs12 layout row wrap class="justify-space-around" align="stretch">
          <v-flex xs12 md4 class="pa-3" layout row align="stretch">
            <v-flex xs12 layout row wrap class="white pa-3 box">
              <v-flex xs12 class="text-xs-center sans title dark">Tipologia di agevolazione</v-flex>
              <v-flex xs12 class="text-xs-center sans text dark">
              <span v-for="(f, index) in item.types" :key="f.name">
                {{f.name || '-'}}
                <span v-if="index != item.types.length - 1">,</span>
              </span>
              </v-flex>
            </v-flex>
          </v-flex>
          <v-flex xs12 md4 class="pa-3" layout row align="stretch">
            <v-flex xs12 layout row wrap class="white pa-3 box">
              <v-flex xs12 class="text-xs-center sans title dark">Finalità</v-flex>
              <v-flex xs12 class="text-xs-center sans text dark">
                <span v-for="(d, index) in item.finalities" :key="d.name">
                  {{d.name || '-'}}<span v-if="index != item.finalities.length - 1">,</span>
                </span>
              </v-flex>
            </v-flex>
          </v-flex>
          <v-flex xs12 md4 class="pa-3" layout row align="stretch">
            <v-flex xs12 layout row wrap class="white pa-3 box">
              <v-flex xs12 class="text-xs-center sans title dark">Stanziamento</v-flex>
              <v-flex xs12 class="text-xs-center sans text dark">
                <span>€ {{parseInt(item.meta_amount, 10).toLocaleString('it-IT', {minimumFractionDigits: 2})}}</span>
              </v-flex>
            </v-flex>
          </v-flex>
        </v-flex>
        <v-flex xs12 class="pa-3 description" v-if="item.meta_description !== null" v-html="$options.filters.marked(item.meta_description)"></v-flex>
        <v-flex xs12 class="garamond text-xs-center pt-3"><h1 class="secondary--text">Caratteristiche</h1></v-flex>
        <v-flex xs12 class="pt-3 pb-4">
          <div class="divider primary"></div>
        </v-flex>

        <v-flex xs12 class="pa-3 mt-3">
          <v-flex class="accent radius pa-4 pr-5 pl-5">
            <v-flex class="title">Beneficiari</v-flex>
            <v-flex class="sans marked" v-if="item.meta_beneficiaries !== undefined" v-html="$options.filters.marked(item.meta_beneficiaries)"></v-flex>
            <v-flex class="sans marked" v-else>
               <span  v-for="(b,index) in item.beneficiaries" :key="b.name">
                {{b.name || '-'}}
                <span v-if="index != item.beneficiaries.length - 1">,</span>
              </span>
            </v-flex>
          </v-flex>
        </v-flex>

        <v-flex xs12 class="pa-3 mt-3" v-if="item.meta_eligible !== undefined && item.meta_eligible !== null">
          <v-flex class="primary radius pa-4 pr-5 pl-5">
            <v-flex class="title">Spese ammissibili</v-flex>
            <v-flex class="sans marked" v-html="$options.filters.marked(item.meta_eligible)"></v-flex>
          </v-flex>
        </v-flex>

        <v-flex xs12 class="pa-3 mt-3" v-if="item.incentive_description !== undefined && item.meta_eligible !== null">
          <v-flex class="accent radius pa-4 pr-5 pl-5">
            <v-flex class="title">Incentivo</v-flex>
            <v-flex class="sans marked" v-html="$options.filters.marked(item.incentive_description)"></v-flex>
          </v-flex>
        </v-flex>

        <v-flex xs12 class="pa-3 mt-3" v-if="item.timing_description !== undefined && item.meta_eligible !== null">
          <v-flex class="primary radius pa-4 pr-5 pl-5">
            <v-flex class="title">Presentazione domanda e tempistiche</v-flex>
            <v-flex class="sans marked" v-html="$options.filters.marked(item.timing_description)"></v-flex>
          </v-flex>
        </v-flex>

        <v-flex xs12 class="garamond text-xs-center pt-4"><h1 class="light secondary--text">Link utili</h1></v-flex>
        <v-flex xs12 class="pt-3 pb-4">
          <div class="divider primary"></div>
        </v-flex>
        <v-flex xs12 layout row wrap class="pa-3 mt-3 mb-5" v-if="item.resources_description !== null">
            <v-flex white class="pa-3 links" xs12 v-html="$options.filters.marked(item.resources_description)"></v-flex>
        </v-flex>

      </v-layout>
        <v-container v-else layout row v-bind:key="2" class="justify-center align-center pt-5 pb-5 abs">
          <v-progress-circular
                  :size="60"
                  :width="3"
                  color="primary"
                  indeterminate
          ></v-progress-circular>
        </v-container>
      </transition-group>
    </v-container>
    <app-footer></app-footer>
  </div>
</template>

<script>

  import moment from 'moment'
  import Header from './header'
  import Footer from './footer'
  import marked from 'marked';

  export default {
    props: ['data'],
    components: {
      'app-header': Header,
      'app-footer': Footer,
    },
    filters: {
      marked: marked,
      bold: function(text) {
        var bold = /\*\*(.*?)\*\*/gm;
        var html = text.replace(bold, '<strong>$1</strong>');
        return html;
      },
      date: function (date) {
        if (!date) {
          return 'N/A'
        }
        return moment(date).locale('it').format('DD MMMM YYYY');
      }
    },
    created: function() {
      this.item = this.data
    },
    data () {
      return {
        item: null
      }
    }
  }
</script>

<style scoped lang="scss">
  .bg{
    background: rgb(237,237,237);
  }
  p{
    margin: 0 !important;
  }
  .light{
    font-weight: 300 !important;
  }
  .marked {
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
  }
  .title{
    font-size: 24px !important;
  }
  .description{
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
    color: var(--v-secondary-base);
  }
  .radius{
    border-radius: 12px;
    color: #FFFFFF;
    .title{
      padding: 14px 0 16px 0;
      text-align: center;
      font-weight: bold;
    }
  }
  .lead{
    font-size: 36px !important;
    font-weight: bold;
    padding: 70px 0 60px 0;
    line-height: 3rem;
  }
  .dark{
    color: var(--v-secondary-base);
  }
  .links{
    border-radius: 3px;
  }
  .box{
    border-radius: 3px;
    .title{
      padding: 0;
      font-weight: bold;
      font-size: 22px !important;
      line-height: 1.75rem !important;
    }
    .text{
      margin-top: 8px;
      font-size: 22px !important;
      line-height: 1.75rem;
      font-weight: normal;
    }
  }
</style>
